import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ActivityFeed } from '../../components';
// import landscape from '../../assets/icons/Landschaft.png';


import {
  TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY,
  txIsAccepted,
  txIsCanceled,
  txIsDeclined,
  txIsEnquired,
  txIsPaymentExpired,
  txIsPaymentPending,
  txIsRequested,
  txHasBeenDelivered,
  txIsBookingPending,
  txIsConfirmed,
} from '../../util/transaction';

import { useState , useEffect } from 'react';
import deepl from 'deepl';
import css from './TransactionPanel.css';
import deepcopy from 'deepcopy';


// Functional component as a helper to build ActivityFeed section
const FeedSection = props => {
  const [translateCheck,setTranslateCheck] = useState(false)
  
  const [translateLanguage,setTranslateLanguage] = useState("EN-GB")

  const langObjArray =[
    {value:"EN", lang:"English"},
    {value:"CS", lang:"Czech"},
    {value:"DA", lang:"Danish"},
    {value:"DE", lang:"German"},
    {value:"EL", lang:"Greek"},
    {value:"BG", lang:"Bulgarian"},
    {value:"ES", lang:"Spanish"},
    {value:"ET", lang:"Estonian"},
    {value:"FI", lang:"Finnish"},
    {value:"FR", lang:"French"},
    {value:"HU", lang:"Hungarian"},
    {value:"IT", lang:"Italian"},
    {value:"JA", lang:"Japan"},
    {value:"LT", lang:"Lithuanian"},
    {value:"LV", lang:"Latvian"},
    {value:"NL", lang:"Dutch"},
    {value:"PL", lang:"Polish"},
    {value:"PT", lang:"Portuguese"},
    {value:"RO", lang:"Romanian"},
    {value:"RU", lang:"Russian"},
    {value:"SK", lang:"Slovak"},
    {value:"SV", lang:"Swedish"},
    {value:"ZH", lang:"Chinese"},
  ]



  const {
    className,
    rootClassName,
    currentTransaction,
    currentUser,
    fetchMessagesError,
    fetchMessagesInProgress,
    initialMessageFailed,
    messages,
    oldestMessagePageFetched,
    onShowMoreMessages,
    onOpenReviewModal,
    totalMessagePages,
    isCustomer,
    customerName,
    providerName,
    displayName
  } = props;


  const [translation, setTranslation] = useState(messages)

  const txTransitions = currentTransaction.attributes.transitions
    ? currentTransaction.attributes.transitions
    : [];
  const hasOlderMessages = totalMessagePages > oldestMessagePageFetched;

  const showFeed =
    messages.length > 0 || txTransitions.length > 0 || initialMessageFailed || fetchMessagesError;

  const classes = classNames(rootClassName || css.feedContainer, className);
  
  async function handleClick (){
    let translatedMessages = deepcopy(messages)
      if(translateCheck === false){
        const promise = translatedMessages.map( async (element,index)=>{
          await deepl({
            free_api: true,
            text: element.attributes.content,
            target_lang: translateLanguage,
            auth_key: '9b6ae94b-6c46-62ad-cace-b9e0abb431cf:fx',
          })
          .then(result => {
            //translatedMessages is a copy of the original Messages. If the checkbox is checked, i replace the text and send the new array inside the feed component
            translatedMessages[index].attributes.content = result.data.translations[0].text
          })
          .catch(error => {
              console.error(error);
          }); 
        })
        await Promise.all(promise)
        setTranslation(translatedMessages)
      }else{
        setTranslation(messages)
      }
      setTranslateCheck(!translateCheck)
  }
  
  

  function handleLangChange (e) {
    setTranslateLanguage(e.target.value)
    setTranslateCheck(false)
  }


  return showFeed ? (
    <div className={classes}>
      {/* need to add to de.json file! */}

      {txIsEnquired(currentTransaction)?(isCustomer?(<div><p className={css.feedHeading}>
      </p>
      </div>):(<div><h3 className={css.feedHeading}>
        
      </h3>
      </div>)):txIsAccepted(currentTransaction)?(<h3 className={css.feedHeading}>

      </h3>):null}
      <h3>
      {isCustomer ? (
        <h3 className={css.mainTitle2}>
              <FormattedMessage id="TransactionPanel.activityHeading" values={{ providerName }}/>  
        </h3>
            ) : <h3 className={css.mainTitle2}>
            <FormattedMessage id="TransactionPanel.activityHeading2" values={{ customerName }}/>  
        </h3> }
        {/* <FormattedMessage id="TransactionPanel.activityHeading" values={{ displayName }}/>  */}
        <br/>
        <div className={css.translationWrapper}>

        <select name="languages" className={css.translationSelect}  id="lang" onChange={handleLangChange}>
          {langObjArray.map(element=>{
            return <option value={element.value}>{element.lang}</option>
          })}
        </select> 
        <button className={css.langButton} onClick={handleClick}>{
          translateCheck? 
          <FormattedMessage id="FeedSection.translateCancel"/> :
          <FormattedMessage id="FeedSection.translateTranslate"/>
        }</button>
        </div>



      </h3>
      {initialMessageFailed ? (
        <p className={css.messageError}>
          <FormattedMessage id="TransactionPanel.initialMessageFailed" />
        </p>
      ) : null}
      {fetchMessagesError ? (
        <p className={css.messageError}>
          <FormattedMessage id="TransactionPanel.messageLoadingFailed" />
        </p>
      ) : null}
      <ActivityFeed
        className={css.feed}
        messages={messages}
        translation={translation}
        transaction={currentTransaction}
        currentUser={currentUser}
        hasOlderMessages={hasOlderMessages && !fetchMessagesInProgress}
        onOpenReviewModal={onOpenReviewModal}
        onShowOlderMessages={onShowMoreMessages}
        fetchMessagesInProgress={fetchMessagesInProgress}
      />
    </div>
  ) : null;
};

export default FeedSection;
